import { render, staticRenderFns } from "./IndustryList.vue?vue&type=template&id=0f213edd&lang=pug"
import script from "./IndustryList.vue?vue&type=script&lang=js"
export * from "./IndustryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f213edd')) {
      api.createRecord('0f213edd', component.options)
    } else {
      api.reload('0f213edd', component.options)
    }
    module.hot.accept("./IndustryList.vue?vue&type=template&id=0f213edd&lang=pug", function () {
      api.rerender('0f213edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/IndustryList.vue"
export default component.exports